import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Inventario",
    items: [
      { label: "Inventario",            icon: "fas fa-warehouse", href: "/ListadoInventarios",           perm: "inventarios" },
      { label: "Inventario Desglosado", icon: "fas fa-warehouse", href: "/ListadoInventariosDesglosado", perm: "inventarios" },
      { label: "Inventario Costos",     icon: "fas fa-warehouse", href: "/ListadoInventariosCostos",     perm: "inventarios" },
    ],
  },
  {
    title: "Traspasos",
    items: [
      { label: "Traspasos Salida",  icon: "fas fa-sign-out-alt", href: "/ListadoTraspasosSalida",  perm: "menu_traspasos_salida"  },
      { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt",  href: "/ListadoTraspasosEntrada", perm: "menu_traspasos_entrada" },
    ],
  },
  {
    title: "Ubicaciones y seguimiento",
    items: [
      { label: "Ubicaciones por Artículo", icon: "fas fa-thumbtack",      href: "/ListadoUbicaciones",  perm: "inventarios" },
      { label: "Ubicaciones",              icon: "fas fa-map-marked-alt", href: "/ListadoUbicaciones2", perm: "inventarios" },
      { label: "Almacenes",                icon: "fas fa-warehouse",      href: "/Areas",               perm: "inventarios" },
      { label: "Seguimiento",              icon: "fas fa-search",         href: "/ListadoSeguimiento",  perm: "inventarios" },
    ],
  },
];

function BotonesInventarios() {
  return (
    <MenuGrid
      title="Inventarios"
      subtitle="Stock, traspasos, ubicaciones y seguimiento"
      icon="fas fa-warehouse"
      accent={{ color: "#0ea5e9", bg: "#f0f9ff" }}
      gate="menu_inventarios"
      sections={SECTIONS}
    />
  );
}

export default BotonesInventarios;
